import { Logo as LogoI } from "src/images";
import { cn } from "src/utilities/shadcnUtils";

export const Logo = ({ className, ...props }: { className?: string }) => (
  <LogoI
    className={cn("w-[118px] h-5 max-[600px]:w-[94.4px] max-[600px]:h-4", className)}
    width={118}
    height={20}
    {...props}
  />
);
